<template>
  <el-dialog
    :visible.sync="showDialog"
    custom-class="card"
    @open="doOpen"
    @closed="doClosed"
    append-to-body
  >
    <template v-if="showContent">
      <div class="icon-lock">
        <img src="./../../../assets/images/img-lock.png" alt>
      </div>
      <div class="dialog-title">
        <h5>账户验证</h5>
        <p>请通过 {{userInfo.phoneNo}} 验证您的身份</p>
      </div>
      <div class="dialog-code">
        <el-input
          placeholder="验证码"
          v-model="unlockData.code"
          maxlength="6"
          @keyup.enter.native="doVerify"
        ></el-input>
        <v-code
          class="vcode"
          session-name="TIME_ACCOUNT_UNLOCK"
          action-path="/user-server/user/sendShortMessage"
          :action-data="actionData"
          @send="handleSend"
        ></v-code>
        <div class="gap"></div>
        <transition name="magic">
          <p v-if="showTips">验证码已发送，10分钟有效</p>
        </transition>
      </div>
      <div class="btn-box">
        <button class="btn btn-cancel" @click="showDialog = false;">取消</button>
        <button class="btn btn-save" @click="doVerify">验证</button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import vCode from "./vCode";
import { mapState } from "vuex";
import aes from "@/uitls/aes";
import "@/assets/styles/modify.scss";

export default {
  components: {
    vCode
  },
  computed: {
    ...mapState(["userInfo"]),
    actionData: function() {
      return {
        motion: "unlock",
        phoneNo: this.userInfo.phoneNo
      };
    },
    // dialog show/hide
    showDialog: {
      // getter
      get: function() {
        return this.visible;
      },
      // setter
      set: function(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      unlockData: {
        code: "",
        time: ""
      },
      showTips: false,
      showContent: false
    };
  },
  methods: {
    doClosed() {
      this.showContent = false;
      this.showTips = false;
    },
    doOpen() {
      this.showContent = true;
      this.unlockData.code = "";
    },
    handleSend(t) {
      this.showTips = true;
      //
      this.unlockData.code = "";
      this.unlockData.time = t;
    },
    // verify account by unlock code
    doVerify() {
      if (!this.unlockData.time) {
        this.$message.error("请先获取验证码");
        return;
      }
      this.$http
        .post("/user-server/setting/unlock/acccount", {
          motion: "unlock",
          phoneNo: this.userInfo.phoneNo,
          vCode: this.unlockData.code
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.doUnlock();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log("ERROR", err);
        });
    },
    // write down time(code receive time) & code
    doUnlock() {
      // write into session
      sessionStorage.setItem(
        "ACCOUNT_UNLOCK_DATA",
        JSON.stringify({
          code: aes.Encrypt(this.unlockData.code),
          time: this.unlockData.time
        })
      );
      // write into vuex
      this.$store.commit("setUnlockData", {
        code: this.unlockData.code,
        time: this.unlockData.time
      });

      this.$emit("unlock");
      this.showDialog = false;
    }
  },
  watch: {
    "unlockData.code"() {
      let reg = /[^0-9]+/g;
      let str = this.unlockData.code;
      reg.test(str) && (this.unlockData.code = str.replace(reg, ""));
    }
  },
  mounted: function() {
    let sessionData = sessionStorage.getItem("ACCOUNT_UNLOCK_DATA");
    if (!sessionData) return;
    // get expire time from session and set to unlockData.time
    this.unlockData.time = JSON.parse(sessionData).time || 0;
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/card.scss";
</style>
<style lang="scss">
/* overwrite el-dialog */
.card {
  &.el-dialog {
    width: 440px;
    border-radius: 6px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userInfo/components/cardL.vue